import { RSAA } from 'redux-api-middleware';
import config from '../../config';
export const fetchPawGroupMetrics = () => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/metrics/paw-group`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        'FETCH_PAW_GROUP_METRICS_REQUEST',
        'FETCH_PAW_GROUP_METRICS_SUCCESS',
        'FETCH_PAW_GROUP_METRICS_FAILURE'
      ]
    }
  };
};

export const fetchWorkflowErrorMetrics = () => {
  return {
    [RSAA]: {
      endpoint: `${config.apiRoot}/metrics/workflow-errors`,
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      types: [
        'FETCH_WORKFLOW_ERROR_METRICS_REQUEST',
        'FETCH_WORKFLOW_ERROR_METRICS_SUCCESS',
        'FETCH_WORKFLOW_ERROR_METRICS_FAILURE'
      ]
    }
  };
};

export const resetMetricsFetcherStatus = () => {
  return {
    type: 'METRICS_FETCHER_STATUS_RESET'
  }
}